import { render, staticRenderFns } from "./category-list-toolbar.vue?vue&type=template&id=24457d89&"
import script from "./category-list-toolbar.vue?vue&type=script&lang=js&"
export * from "./category-list-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports